import { Link } from "react-router-dom";
import { RichText } from "@/components/RichText";
import type { CtaFinal as Data } from "@/lib/types";

export default function CtaFinal({ data }: { data: Data }) {
  return (
    <section className="cta-final" id="demo">
      <div className="cta-final-inner">
        <RichText as="h2" className="cta-title display" html={data.title} />
        <p className="cta-sub">{data.sub}</p>
        <div className="cta-ctas">
          <Link to={data.primaryCta.href} className="btn-primary">
            {data.primaryCta.label}
          </Link>
          <Link to={data.secondaryCta.href} className="btn-ghost">
            {data.secondaryCta.label}
          </Link>
        </div>
      </div>
    </section>
  );
}
